import {
    Heading,
    Stack,
    Text,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import StatusSuccess from "components/booking-status/status-icon/status-success";
import { useTranslation } from "react-i18next";

interface IBookingSuccess {
    isWaitList: boolean;
}

export function BookingSuccess({ isWaitList }: IBookingSuccess) {
    const { t } = useTranslation();
    const webBooking = useWebBooking().data;

    const getTitle = () => {
        if (isWaitList) {
            return t("waitList.waitListSuccessTitle");
        }
        if (webBooking?.isInquiry()) {
            return t("bookingRequest.success.title");
        }
        if (webBooking?.proposalAcceptedByGuest()) {
            return t("bookingRequest.respond.accepted.title");
        }

        return t("thanks");
    };

    const getMessage = () => {
        if (isWaitList) {
            return t("waitList.waitListSuccessMessage");
        }
        if (webBooking?.isInquiry()) {
            return t("bookingRequest.success.message");
        }
        if (webBooking?.proposalAcceptedByGuest()) {
            return t("bookingRequest.respond.accepted.message");
        }

        return t("bookingSuccessMessage");
    };

    return (
        <Stack
            alignItems="center"
            spacing={ThemeSpaceVariable.Medium}
            pt={ThemeSpaceVariable.Large}
        >
            <StatusSuccess />
            <Stack alignItems="center" spacing={ThemeSpaceVariable.Small}>
                <Heading as="h1" fontWeight="500" textAlign="center">
                    {getTitle()}
                </Heading>
                <Text textAlign="center" fontSize={ThemeFontSizeVariable.Large}>
                    {getMessage()}
                </Text>
            </Stack>
        </Stack>
    );
}
